export const DROPDOWN_PAGE_SIZE = 30

export type SearchFieldType = 'string' | 'number'

export type SearchField = string | { field: string; type?: SearchFieldType }

const toUpperSnakeCase = (s: string) =>
  s.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase()

export const getSearchFieldName = (field: SearchField) =>
  typeof field === 'string' ? field : field.field

export const buildSearchFilter = (
  searchTerm: string,
  searchFields: SearchField[]
): Record<string, unknown>[] => {
  if (!searchTerm?.trim()) return []

  const fields = searchFields.length ? searchFields : ['name']

  const makeFilter = (field: SearchField) => {
    const isNumber = typeof field !== 'string' && field.type === 'number'
    return {
      field: toUpperSnakeCase(getSearchFieldName(field)),
      operator: isNumber ? 'EQUALS' : 'CONTAINS',
      values: [
        isNumber
          ? { numberValue: Number(searchTerm) }
          : { stringValue: searchTerm }
      ]
    }
  }

  const filters = fields.map(makeFilter)
  return filters.length > 1 ? [{ or: filters }] : filters
}
